import { render, staticRenderFns } from "./AccessControlV2.vue?vue&type=template&id=9eee9830&"
import script from "./AccessControlV2.vue?vue&type=script&lang=ts&"
export * from "./AccessControlV2.vue?vue&type=script&lang=ts&"
import style0 from "./AccessControlV2.vue?vue&type=style&index=0&id=9eee9830&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports